import * as React from 'react';
import { ArrowDown, ArrowUp } from '@components/atoms/icons';
import { FloatingPanelPositionEnum } from './types';
import type { IPositionMoveControl } from './types';

interface IPositionToggleButtonProps {
	moveControl: IPositionMoveControl;
	testId: string;
	compact?: boolean;
}

/**
 * Returns true when the panel is anchored to the top of the viewport.
 */
function isTopPosition(position: FloatingPanelPositionEnum): boolean {
	switch (position) {
		case FloatingPanelPositionEnum.TOP_RIGHT:
		case FloatingPanelPositionEnum.TOP_LEFT:
			return true;
		case FloatingPanelPositionEnum.BOTTOM_RIGHT:
		case FloatingPanelPositionEnum.BOTTOM_LEFT:
			return false;
		default: {
			const _exhaustive: never = position;
			return _exhaustive;
		}
	}
}

export const PositionToggleButton: React.FC<IPositionToggleButtonProps> = ({
	moveControl,
	testId,
	compact = false,
}) => {
	const movesDown = isTopPosition(moveControl.position);
	const ariaLabel = movesDown ? moveControl.moveToBottomAriaLabel : moveControl.moveToTopAriaLabel;
	const Icon = movesDown ? ArrowDown : ArrowUp;

	return (
		<button
			type="button"
			onClick={moveControl.onToggle}
			className={
				compact
					? 'size-5 flex items-center justify-center text-tertiary hover:text-primary hover:bg-black/5 rounded-full transition-colors'
					: 'size-7 flex items-center justify-center text-secondary hover:text-primary hover:bg-black/5 rounded-lg transition-all duration-150'
			}
			aria-label={ariaLabel}
			title={ariaLabel}
			data-testid={testId}
		>
			<Icon className={compact ? 'size-3' : 'size-4'} />
		</button>
	);
};
